var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-close-circle-outline",
    "data-name": "Icon ionic-ios-close-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1",
    "data-name": "Tracciato 1",
    d: "M42.267,37.93,32.133,27.8,42.267,17.661a3.073,3.073,0,0,0-4.346-4.346L27.787,23.449,17.652,13.315a2.94,2.94,0,0,0-4.346,0,2.969,2.969,0,0,0,0,4.346L23.44,27.8,13.306,37.93a2.971,2.971,0,0,0,0,4.346,3.053,3.053,0,0,0,4.346,0L27.787,32.142,37.921,42.276a3.088,3.088,0,0,0,4.346,0A3.053,3.053,0,0,0,42.267,37.93Z",
    transform: "translate(15.588 15.58)",
    fill: "#d20790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2",
    "data-name": "Tracciato 2",
    d: "M43.375,8.76a34.621,34.621,0,0,1,24.481,59.1A34.621,34.621,0,0,1,18.894,18.894,34.386,34.386,0,0,1,43.375,8.76m0-5.385a40,40,0,1,0,40,40,39.994,39.994,0,0,0-40-40Z",
    fill: "#d20790"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircle);
export default __webpack_public_path__ + "static/media/error-circle.3dd8ad55230b9866894e6a841b52ad19.svg";
export { ForwardRef as ReactComponent };